import { createFileRoute } from '@tanstack/react-router';
import { useState, useEffect } from 'react';
import { SubscriptionSettings } from '@/pet/src/components/shared/SubscriptionSettings';
import { WalletSettings } from '@/pet/src/components/settings/WalletSettings';
import { useAuth } from '@/context/AuthContext';
import { useSubscription } from '@/pet/src/context/SubscriptionContext';
import { apiClient } from '@/api/axios';
import { Loader2 } from 'lucide-react';

export const Route = createFileRoute('/dashboard/settings/wallet')({
  component: WalletPage,
});

interface UserProfileResponse {
  user: {
    walletAddress?: string;
  };
}

function WalletPage() {
  const { user } = useAuth();
  const { getProductConfig } = useSubscription();
  const petsoProduct = getProductConfig('petso');
  const [walletAddress, setWalletAddress] = useState<string | undefined>(
    user?.walletAddress
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchWalletAddress = async () => {
      try {
        const response =
          await apiClient.get<UserProfileResponse>('/users/profile');
        if (response.data?.user?.walletAddress) {
          setWalletAddress(response.data.user.walletAddress);
        }
      } catch (error) {
        console.error('Failed to fetch wallet address:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchWalletAddress();
  }, []);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="w-8 h-8 animate-spin text-purple-600" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <SubscriptionSettings
        platform="petso"
        currentPlan="free"
        billingCycle="annual"
        nextBillingDate="2025-01-22"
        billingEnabled={petsoProduct?.billingEnabled ?? false}
      />
      <div className="mt-6">
        <WalletSettings
          walletAddress={walletAddress}
          authMethod={user?.authMethod}
        />
      </div>
    </div>
  );
}
